import { render, staticRenderFns } from "./RelativeProduct.vue?vue&type=template&id=7b83c80a&scoped=true"
import script from "./RelativeProduct.vue?vue&type=script&lang=js"
export * from "./RelativeProduct.vue?vue&type=script&lang=js"
import style0 from "./RelativeProduct.vue?vue&type=style&index=0&id=7b83c80a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b83c80a",
  null
  
)

export default component.exports